export const NOTICE_ENTITY_PLACEHOLDER = '{entity}';

export interface NoticeMessageParts {
  before: string;
  after: string | null;
}

export function parseNoticeMessage(message: string): NoticeMessageParts {
  const index = message.indexOf(NOTICE_ENTITY_PLACEHOLDER);

  if (index === -1) {
    return { before: message, after: null };
  }

  return {
    before: message.slice(0, index),
    after: message.slice(index + NOTICE_ENTITY_PLACEHOLDER.length),
  };
}
